import { Marked } from './marked';
import { DIV, SPAN } from '../../components/elements';

export const markdown = (source: string, className = 'md') =>
    DIV({ className }, ...Marked.parse(source));

export const markdownSpan = (source: string, className = 'md') =>
    SPAN({ className }, ...Marked.parse(source));
